import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from "react";
import "./styles.css";
import { useHistory, useParams, useLocation } from "react-router";

import { ReactComponent as CancelIcon } from "common/assets/svg/closeiconnew.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import {
  getDecimalPlacedPrice,
  getDecimalPlacedPriceString,
  getTwoDecimalValue,
} from "common/utils/menu-helper-utils";
import { CartTotal } from "common/features/cart/cartModels";
import DummyImageRestaurant from "common/assets/images/dishPlaceholder.png";
import Tipimg1 from 'common/assets/images/tipimg1.png'
import Tipimg2 from 'common/assets/images/tipimg2.png'
import Tipimg3 from 'common/assets/images/tipimg3.png'
import Tipimg4 from 'common/assets/images/tipimg4.png'
import Tipimg5 from 'common/assets/images/tipimg5.png'
import { updateOrderTipDetail } from "common/features/order/orderActions";

import {
  saveOrderDetails,
  removeCartTip,
} from "common/features/cart/cartActions";
import { useMemo } from "react";
import { toast } from "react-toastify";
import { useOnlinePlaceOrder } from "hooks/useOnlinePlaceOrder";
export interface TipProps {
  isVisible: boolean;
  setIsVisible: any;
  totalPrice?: number;
  isTipOpen: boolean
  images?: any
}



const AddTip = (props: TipProps) => {
  const dispatch = useDispatch();
  let paramsData = useParams<any>();

  let { merchantType, restaurantSlug, menuType, tableId, orderId } =
    useParams<any>();
  const isMobile = window.innerWidth <= 500;

  const history = useHistory();


  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      event.stopPropagation();
      props.setIsVisible(false);
      // Push a new entry to prevent navigation
      window.history.pushState(null, '', window.location.href);
    };

    // Add initial history entry
    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handleBackButton);

    // Handle native Android back button
    const handleNativeBack = () => {
      props.setIsVisible(false);
      window.history.pushState(null, '', window.location.href);
    };

    // Add event listener for native back button
    document.addEventListener('backbutton', handleNativeBack, false);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
      document.removeEventListener('backbutton', handleNativeBack);
    };
  }, [props.setIsVisible]);

  // const [
  //   makeOrder,
  //   totalItemsubTotal,
  //   totalOrderPrice,
  //   totalTaxAndCharges,
  //   totalItemTaxAmount,
  //   tipAmount1,
  //   packagingCharge,
  //   discountAmount,
  //   serviceCharge,
  //   updateOrder,
  //   walletAmount,
  //   RedeemedWalletAmt,
  // ] = usePlaceOrder();

  const [makeOrder, updateOrder, orderTotal, itemTotal, orderTotals, tipAmount1, discountAmount, deliveryFee] = useOnlinePlaceOrder();

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail?.country
  );

  const currentOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );
  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );

  const isDeliveryOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        if (menuType) {
          return orderType.typeName == menuType && orderType.typeGroup == "S";
        } else
          return (
            currentOrderTypeId == orderType.id && orderType.typeGroup == "S"
          );
      }) || false
    );
  }, [restaurantDetails, menuType, currentOrderTypeId]);

  const toastId = React.useRef<any>(null);

  const notify = (message: string) =>
  (toastId.current = toast.error(message, {
    position: toast.POSITION.TOP_CENTER,
  }));

  const isPickupOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        if (menuType) {
          return orderType.typeName == menuType && orderType.typeGroup == "P";
        } else
          return (
            currentOrderTypeId == orderType.id && orderType.typeGroup == "P"
          );
      }) || false
    );
  }, [restaurantDetails, menuType, currentOrderTypeId]);
  const [tipAmount, setTipAmount] = useState<any>(0);
  const [tipData1, setTipData1] = useState<any>([]);
  const [tipData2, setTipData2] = useState<any>([]);
  const tipValue = useSelector((state: RootState) => state.cart.tipValue);
  //const tipValue = useSelector((state: RootState) => state.order.tip);
  const isAppliedTip = useSelector((state: RootState) => state.cart.isAppliedTip);



  useEffect(() => {
    if (tipAmount1) {
      setTipAmount(tipAmount1);
    }
  }, [tipAmount1]);

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails.media.length > 0) {
        const logoMedia = restaurantDetails.media.filter(
          (media) => media.entityType == type
        )[0];
        return (
          process.env.REACT_APP_IMAGE_URL +
          logoMedia.mimeType.split("/")[0] +
          "/" +
          logoMedia.id +
          "." +
          logoMedia.mimeType.split("/")[1]
        );
      } else {
        return DummyImageRestaurant;
      }
    },
    [restaurantDetails]
  );

  useEffect(() => {
    setTipData1([
      { tip: "10", selected: false },
      { tip: "15", selected: false },
      { tip: "18", selected: false },
    ]);

    setTipData2([
      { tip: "20", selected: false },
    ]);
  }, [restaurantCountry]);

  const [percentValue, setPercentValue] = useState("");
  const [selectedPercent, setSelectedPercent] = useState<string | null>();



  const isPercentSelected = (perc: string) => {
    return perc == selectedPercent;
  };

  const isFlatSelected = (perc: string) => {
    return Number(perc) == Number(selectedPercent);
  };

  // const percentageValue = (perc: number) => {
  //   return (
  //     getTwoDecimalValue(
  //       ((Number(perc) / 100) * Number(props.totalPrice))
  //     ) === tipAmount
  //   );
  // };

  const calculatePercentage = (value: number) => {
    return getTwoDecimalValue(
      ((Number(value) / 100) * Number(itemTotal))
    );
  };


  useEffect(() => {
    if (tipValue === 0) {
      if (!isAppliedTip && restaurantCountry === "US" && tipValue == 0) {
        setPercentValue("");
        setSelectedPercent("")
      }
      else if (isAppliedTip && tipValue == 0) {
        setSelectedPercent("Enter Amount");
        setPercentValue("0")
      } else {
        setPercentValue("");
      }
    } else {
      // console.log("above 0");
      setPercentValue("");
      setSelectedPercent("");
      setPercentValue(tipValue + "");
      setSelectedPercent(tipValue.toString())
    }
  }, [tipValue, isAppliedTip]);

  useEffect(() => {
    if (restaurantCountry == "IN") {
      if (tipAmount1 > '0') {
        setSelectedPercent(tipAmount1 + "");
      }

      if (
        tipAmount1 == 0 ||
        tipAmount1 == 5 ||
        tipAmount1 == 10 ||
        tipAmount1 == 18 ||
        tipAmount1 == 20 ||
        tipAmount1 == 25
      ) {
      } else {
        // setPercentValue(tipAmount1 + "");
        setSelectedPercent("Enter Amount");
      }
    } else {
      if (
        tipAmount1 == calculatePercentage(0) ||
        tipAmount1 == calculatePercentage(5) ||
        tipAmount1 == calculatePercentage(10) ||
        tipAmount1 == calculatePercentage(18) ||
        tipAmount1 == calculatePercentage(20) ||
        tipAmount1 == calculatePercentage(25)
      ) {
      } else {
        // setPercentValue(tipAmount1 + "");
        setSelectedPercent("Enter Amount");
      }
    }
  }, [tipAmount1]);

  const isIndianRestaurant = useMemo(() => {
    return restaurantCountry == "IN";
  }, [restaurantCountry]);

  let invalidChars = ["-", "+", "e"];
  const images: any = [
    {
      img: Tipimg1
    },
    {
      img: Tipimg2
    },
    {
      img: Tipimg3
    },
    {
      img: Tipimg4
    },
    {
      img: Tipimg5
    }
  ];

  const [randomImage, setRandomImage] = useState('');

  const tipOptions = [
    { percentage: "5", amount: "1.29" },
    { percentage: "10", amount: "2.29" },
    { percentage: "18", amount: "2.99" },
    { percentage: "20", amount: "3.29" },
    { percentage: "25", amount: "3.29" },

  ];
  const [customTipErrorMsg, setCustomTipErrorMsg] = useState("");

  const [shownIndices, setShownIndices] = useState<number[]>([]);


  const getTipImage = useMemo(() => {

    const array = [Tipimg1, Tipimg2, Tipimg3, Tipimg4, Tipimg5];
    return array[Math.floor(Math.random() * array.length)];
  }, [])


  // useEffect(() => {
  //   showRandomImage();
  // }, []);

  const showRandomImage = () => {
    let remainingIndices = props?.images?.map((_: any, index: number) => index)
      .filter((index: any) => !shownIndices.includes(index));
    if (remainingIndices?.length === 0) {
      remainingIndices = props?.images?.map((_: any, index: number) => index);
      setShownIndices([]);
    }
    const randomIndex = remainingIndices && remainingIndices[Math.floor(Math.random() * remainingIndices.length)];
    setRandomImage(props?.images[randomIndex].img);
    setShownIndices(prev => [...prev, randomIndex]);
  };

  //  const shownImagesRef = useRef<number[]>([]);
  //   const lastIndexRef = useRef<number | null>(null);

  // useEffect(() => {
  //   const getNextImage = () => {

  //     if (shownImagesRef.current.length === images.length) {
  //       shownImagesRef.current = [];
  //     }

  //     let index: number;

  //     do {
  //       index = Math.floor(Math.random() * images.length);
  //     } while (
  //       shownImagesRef.current.includes(index) || 
  //       index === lastIndexRef.current
  //     );

  //     shownImagesRef.current.push(index);
  //     lastIndexRef.current = index;
  //     setRandomImage(images[index].img);
  //   };

  //   getNextImage();
  // }, []);

  const shownImagesRef = useRef<number[]>([]);
  const lastIndexRef = useRef<number | null>(null);

  // useEffect(() => {
  //   if (props.isTipOpen && images && images.length > 0) {
  //     const getNextImage = () => {
  //       const imagesarray =images;

  //       // Reset if all images have been shown
  //       if (shownImagesRef.current.length === imagesarray.length) {
  //         shownImagesRef.current = [];
  //       }

  //       let index: number;
  //       let attempts = 0;
  //       const maxAttempts = 10;

  //       do {
  //         index = Math.floor(Math.random() * imagesarray.length);
  //         attempts++;
  //       } while (
  //         (shownImagesRef.current.includes(index) || index === lastIndexRef.current) &&
  //         attempts < maxAttempts
  //       );

  //       shownImagesRef.current.push(index);
  //       lastIndexRef.current = index;

  //     setRandomImage(imagesarray[index].img);
  //     };

  //     getNextImage();
  //   }
  // }, []);
  const isContactlessDineInOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        (restaurantDetails.dining == 2 || restaurantDetails.dining == 3) &&
        paramsData.tableId &&
        paramsData.tableId.length > 0
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes, restaurantDetails]);

  return (
    <Fragment>
      {props.isVisible && props.totalPrice > 0 ? (
        <Fragment>
          <div className={isMobile ? "Tip-popup-overlayZa-M" : "Tip-popup-overlayZa"}>

            <div style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              position: "relative",
            }}>

              <div style={{
                width: isMobile ? "100%" : "26%",
                minHeight: isMobile ? "100%" : "60%",
                padding: isMobile ? "0px" : "10px",
                backgroundColor: "#ffffff",
                marginRight: isMobile ? "0px" : "180px",
                borderRadius: isMobile ? "0px" : "15px"
              }}>
                <div style={{
                  width: "100%",
                  //height: isMobile ? "40vh" : "50%", 
                  minHeight: isMobile ? "200px" : "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderTopLeftRadius: isMobile ? "0px" : "15px",
                  borderTopRightRadius: isMobile ? "0px" : "15px",
                  overflow: "hidden",
                  position: "relative"
                }}>
                  <img
                    src={getTipImage}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "fill",
                      objectPosition: "center",
                      backgroundColor: "white",
                      borderRadius: isMobile ? "0px" : "15px"
                    }}
                  />

                  {isMobile &&
                    <button className="close-btnZa-Tip" onClick={() => { props.setIsVisible(false); }}>
                      <CancelIcon className="tipCancel-btn" />
                    </button>
                  }

                </div>

                <div className={isMobile ? "Tip-card-new-M" : "Tip-card-new"} >

                  <div style={{ backgroundColor: "white", borderBottomLeftRadius: isMobile ? "0px" : "15px", borderBottomRightRadius: isMobile ? "0px" : "15px", padding: isMobile ? 8 : 15 }}>
                    <div className={isMobile ? "tip-grid-M" : "tip-grid"}>
                      {tipOptions?.map((data: any) => (
                        isIndianRestaurant ?
                          <button
                            key={data.percentage}
                             style={{

                              width: restaurantCountry == "IN" ? isMobile ? "44vw" : "30%" : isMobile ? "44vw" : "30%",
                              height: restaurantCountry == "IN" ? isMobile ? "44px" : "43.6px" : isMobile ? "44px" : "43.6px"
                            }}
                            className={`${isMobile ? "tip-button-M" : "tip-button"} ${isFlatSelected(data.percentage) ? "selected" : ""}`}
                            onClick={() => {
                              setSelectedPercent(data.percentage);
                              setPercentValue('');
                            }}

                          >
                            &#x20B9;{data.percentage}

                          </button> :

                          <button
                            key={data.percentage}
                            className={`${isMobile ? "tip-button-M" : "tip-button"} ${isFlatSelected(data.percentage) ? "selected" : ""
                              }`}
                            style={{

                              width: restaurantCountry == "IN" ? isMobile ? "44vw" : "83.3px" : isMobile ? "44vw" : "30%",
                              height: restaurantCountry == "IN" ? isMobile ? "55px" : "43.6px" : isMobile ? "44px" : "43.6px"
                            }}
                            onClick={() => {
                              setSelectedPercent(data.percentage);


                              setTipAmount(
                                getTwoDecimalValue(
                                  (
                                    (Number(data.percentage) / 100) *
                                    Number(props.totalPrice)
                                  )
                                )
                              );
                              setPercentValue('');
                            }}
                          >
                            {data.percentage}%  (&#36;{getTwoDecimalValue(
                              (
                                (Number(data.percentage) / 100) *
                                Number(props.totalPrice)
                              )
                            )})
                          </button>
                      ))}

                      <button
                        className={`${isMobile ? "tip-button-M" : "tip-button"} custom ${isPercentSelected("Enter Amount") ? "selected" : ""
                          }`}
                        style={{
                          width: restaurantCountry == "IN" ? isMobile ? "44vw" : "30%" : isMobile ? "44vw" : "30%",
                          height: restaurantCountry == "IN" ? isMobile ? "44px" : "43.3px" : isMobile ? "44px" : "43.6px"
                        }}
                        onClick={() => {
                          setSelectedPercent("Enter Amount");
                          setPercentValue("");
                        }}
                      >
                        Custom
                      </button>
                    </div>

                    <div className="tip-error-msg">{customTipErrorMsg}</div>
                    {selectedPercent == "Enter Amount" && (
                      <div
                        className={isMobile ? "tip-input-container-M" : "tip-input-container"}

                      >
                        <input
                          type="number"
                          placeholder="Enter tip amount"
                          className="tip-input"
                          value={percentValue}
                          onPaste={(e) => e.preventDefault()}
                          onKeyDown={(e: any) => {
                            if (
                              restaurantCountry == "IN"
                              &&
                              e.target.value.length === 0 &&
                              e.key == "0"
                            ) {
                              e.preventDefault();
                            }
                            if (invalidChars.includes(e.key) || e.key === "-" || e.key === "e") {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value.length == 6) return false;
                            const value = e.target.value;


                            const isValidInput = /^\d*\.?\d{0,2}$/.test(value);
                            if (isValidInput) {
                              setPercentValue(value);
                            }

                          }}
                        />
                      </div>
                    )}

                    <div className={isMobile ? "thanksMessag-new" : "thanksMessag-new-D"} style={{ marginTop: !isMobile && selectedPercent !== "Enter Amount" ? "40px" : "5px" }}>
                      <p>Kindness travels with your order, 100% of the tip amount goes to the delivery partner. </p>
                    </div>


                    <div className={isMobile ? "tip-buttons-M" : "tip-buttons"} style={{ marginTop: isMobile && selectedPercent !== "Enter Amount" ? "35px" : !isMobile && selectedPercent !== "Enter Amount" ? "25px" : "" }}>
                      {
                        !isMobile && <button className="Later-button" onClick={() => {

                          props.setIsVisible(false);
                        }}>Cancel</button>
                      }

                      <button
                        className={isMobile ? "add-Tip-button-M" : "add-Tip-button-D"}
                        style={{
                          background:
                            selectedPercent &&
                              (selectedPercent !== "Enter Amount" ||
                                (selectedPercent === "Enter Amount" &&
                                  percentValue !== ""))
                              ? "#67833e"
                              : "grey",
                          width: "100%",
                          marginBottom: isMobile ? "50px" : "0px"
                        }}
                        onClick={() => {
                          if (
                            selectedPercent &&
                            (selectedPercent !== "Enter Amount" ||
                              (selectedPercent === "Enter Amount" && percentValue !== ""

                              ))
                          ) {
                            if (props.totalPrice > 0) {
                              if (selectedPercent == "Enter Amount") {

                                let tipAmount = percentValue.replace(
                                  /[^0-9.]/g,
                                  ""
                                );
                                if (tipAmount.length >= 0 && (restaurantCountry === "IN" ? Number(tipAmount) >= 1 : tipAmount)) {
                                  dispatch(
                                    saveOrderDetails({
                                      tipValue:
                                        restaurantCountry === "US"
                                          ? parseFloat(tipAmount)
                                          : parseFloat(tipAmount),
                                      tipType: "FLATFEE",
                                    })
                                  );
                                  props.setIsVisible(false);
                                } else {
                                  notify("cannot add less than 1");
                                }

                              } else if (selectedPercent == "0") {
                                isContactlessDineInOrder &&
                                  dispatch(
                                    updateOrderTipDetail({
                                      tipAmount: 0,
                                      orderId: orderId,
                                      transactionId: "",
                                    })
                                  );
                                dispatch(
                                  saveOrderDetails({
                                    tipValue: 0,
                                    tipType: "FLATFEE",
                                  })
                                );
                                props.setIsVisible(false);
                              } else {
                                if (selectedPercent) {
                                  if (restaurantCountry === "US") {
                                    dispatch(
                                      saveOrderDetails({
                                        tipValue: +selectedPercent,
                                        tipType: "PERCENT",
                                      })
                                    );
                                  } else {
                                    isContactlessDineInOrder &&
                                      dispatch(
                                        updateOrderTipDetail({
                                          tipAmount: +selectedPercent,
                                          orderId: orderId,
                                          transactionId: "",
                                        })
                                      );
                                    dispatch(
                                      saveOrderDetails({
                                        tipValue: +selectedPercent,
                                        tipType: "FLATFEE",
                                      })
                                    );
                                  }
                                }
                                props.setIsVisible(false);
                              }
                              // setSelectedPercent("");
                            } else {
                              props.setIsVisible(false);
                            }
                          }
                        }}
                      >
                        Confirm Tip
                      </button>

                    </div>
                  </div>

                </div>

              </div>

            </div>



            {/* <div className={isMobile ? "Tip-popup-contentZa" : "AddTipDesktop"}>

              <div className="tip-container-with-img" >

                <div className={isMobile ? "tip-images-new-mobile" : "tip-images-new"}>

                  <img src={getTipImage} alt="" className="tip-img"   />
                  {
                        isMobile && 
                        <button className="close-btnZa-Tip" onClick={() => {
                 
                          props.setIsVisible(false);
                        }}>

                          <CancelIcon
                            className="tipCancel-btn"
                          />
                        </button>
                      }

                </div>

                {
                  true &&

                  <div className="Tip-container-new">



                    <div className={isMobile ?"Tip-card-new-M":"Tip-card-new" }>

                      <div className={isMobile ? "tip-grid-M" : "tip-grid"}>
                        {tipOptions?.map((data: any) => (
                          isIndianRestaurant ?
                            <button
                              key={data.percentage}
                              className={`${isMobile ? "tip-button-M" : "tip-button"} ${isFlatSelected(data.percentage) ? "selected" : ""
                                }`}
                              onClick={() => {
                                setSelectedPercent(data.percentage);


                                setPercentValue('');
                              }}
                               style={{
                      
                      width: restaurantCountry == "IN" ?isMobile?"140.4px": "83.3px" : isMobile?"140.4px":"98.84px",
                      height: restaurantCountry == "IN" ?isMobile?"55px": "43.6px" : isMobile?"55px":"43.6px"
                    }}
          >
                              &#x20B9;{data.percentage}
                    
                            </button> :

                            <button
                              key={data.percentage}
                              className={`${isMobile ? "tip-button-M" : "tip-button"} ${isFlatSelected(data.percentage) ? "selected" : ""
                                }`}
                                 style={{
                      
                     width: restaurantCountry == "IN" ?isMobile?"140.4px": "83.3px" : isMobile?"140.4px":"98.84px",
                      height: restaurantCountry == "IN" ?isMobile?"55px": "43.6px" : isMobile?"55px":"43.6px"
                    }}
                              onClick={() => {
                                setSelectedPercent(data.percentage);


                                setTipAmount(
                                  getTwoDecimalValue(
                                    (
                                      (Number(data.percentage) / 100) *
                                      Number(props.totalPrice)
                                    )
                                  )
                                );
                                setPercentValue('');
                              }}
                            >
                              {data.percentage}%  (&#36;{getTwoDecimalValue(
                                    (
                                      (Number(data.percentage) / 100) *
                                      Number(props.totalPrice)
                                    )
                                  )})
                            </button>
                        ))}

                        <button
                          className={`${isMobile ? "tip-button-M" : "tip-button"} custom ${isPercentSelected("Enter Amount") ? "selected" : ""
                            }`}
                             style={{
                      
                       width: restaurantCountry == "IN" ?isMobile?"140.4px": "83.3px" : isMobile?"140.4px":"98.84px",
                      height: restaurantCountry == "IN" ?isMobile?"55px": "43.3px" : isMobile?"55px":"43.6px"
                    }}
                          onClick={() => {
                            setSelectedPercent("Enter Amount");
                            setPercentValue("");
                          }}
                        >
                          Custom
                        </button>
                      </div>

                      <div className="tip-error-msg">{customTipErrorMsg}</div>
                      {selectedPercent == "Enter Amount" && (
                        <div
                          className={isMobile ? "tip-input-container-M" : "tip-input-container"}
                
                        >
                          <input
                            type="number"
                            placeholder="Enter tip amount"
                            className="tip-input"
                            value={percentValue}
                            onPaste={(e) => e.preventDefault()}
                            onKeyDown={(e: any) => {
                              if (
                                restaurantCountry == "IN"
                                &&
                                e.target.value.length === 0 &&
                                e.key == "0"
                              ) {
                                e.preventDefault();
                              }
                              if (invalidChars.includes(e.key) || e.key === "-" || e.key === "e") {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              if (e.target.value.length == 6) return false;
                              const value = e.target.value;


                              const isValidInput = /^\d*\.?\d{0,2}$/.test(value);
                              if (isValidInput) {
                                setPercentValue(value);
                              }
   
                            }}
                          />
                        </div>
                      )}

                       <div className={isMobile?"thanksMessag-new":"thanksMessag-new-D"} style={{marginTop: !isMobile && selectedPercent !== "Enter Amount"?"40px":"5px"}}>
                    "We truly appreciate your tip. It means a lot to our staff."
                  </div>


                      <div className={isMobile ? "tip-buttons-M" : "tip-buttons"} style={{ marginTop: isMobile && selectedPercent !== "Enter Amount" ? "35px" :  !isMobile && selectedPercent !== "Enter Amount"?"25px":""}}>
                        {
                          !isMobile && <button className="Later-button" onClick={() => {
                      
                            props.setIsVisible(false);
                          }}>Cancel</button>
                        }

                        <button
                          className={isMobile ? "add-Tip-button-M" : "add-Tip-button-D"}
                           style={{
                      background:
                        selectedPercent &&
                        (selectedPercent !== "Enter Amount" ||
                          (selectedPercent === "Enter Amount" &&
                            percentValue!==""))
                          ? "#67833e"
                          : "grey",
                      width: "100%",
                    }}
                          onClick={() => {
                            if (
                              selectedPercent &&
                              (selectedPercent !== "Enter Amount" ||
                                (selectedPercent === "Enter Amount" && percentValue!==""
                            
                                ))
                            ) {
                              if (props.totalPrice > 0) {
                                if (selectedPercent == "Enter Amount") {
                           
                                  let tipAmount = percentValue.replace(
                                    /[^0-9.]/g,
                                    ""
                                  );
                                  if (tipAmount.length >= 0 && (restaurantCountry === "IN" ? Number(tipAmount) >= 1 : tipAmount)) {
                                    dispatch(
                                      saveOrderDetails({
                                        tipValue:
                                          restaurantCountry === "US"
                                            ? parseFloat(tipAmount)
                                            : parseFloat(tipAmount),
                                        tipType: "FLATFEE",
                                      })
                                    );
                                    props.setIsVisible(false);
                                  } else {
                                    notify("cannot add less than 1");
                                  }

                                } else if (selectedPercent == "0") {
                                  isContactlessDineInOrder &&
                                    dispatch(
                                      updateOrderTipDetail({
                                        tipAmount: 0,
                                        orderId: orderId,
                                        transactionId: "",
                                      })
                                    );
                                  dispatch(
                                    saveOrderDetails({
                                      tipValue: 0,
                                      tipType: "FLATFEE",
                                    })
                                  );
                                  props.setIsVisible(false);
                                } else {
                                  if (selectedPercent) {
                                    if (restaurantCountry === "US") {
                                      dispatch(
                                        saveOrderDetails({
                                          tipValue: +selectedPercent,
                                          tipType: "PERCENT",
                                        })
                                      );
                                    } else {
                                      isContactlessDineInOrder &&
                                        dispatch(
                                          updateOrderTipDetail({
                                            tipAmount: +selectedPercent,
                                            orderId: orderId,
                                            transactionId: "",
                                          })
                                        );
                                      dispatch(
                                        saveOrderDetails({
                                          tipValue: +selectedPercent,
                                          tipType: "FLATFEE",
                                        })
                                      );
                                    }
                                  }
                                  props.setIsVisible(false);
                                }
                                // setSelectedPercent("");
                              } else {
                                props.setIsVisible(false);
                              }
                            }
                          }}
                        >
                          Confirm Tip
                        </button>

                      </div>


                    </div>
                  </div>
                }


              </div>
            </div> */}
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  );
};
export default AddTip;
